export const LOCATION_PARAMS = ['lat', 'lng', 'postalCode'];

/** Returns a copy of `prev` without any `LOCATION_PARAMS`. */
export function clearLocationParams(prev: URLSearchParams) {
  const params = new URLSearchParams(prev);
  LOCATION_PARAMS.map((param) => params.delete(param));
  return params;
}
